import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import CoreButtonHoverIcon from "../../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import FolderRoundedIcon from "@mui/icons-material/FolderRounded";
import FileDownloadRoundedIcon from "@mui/icons-material/FileDownloadRounded";
import MemoryOutlinedIcon from "@mui/icons-material/MemoryOutlined";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import { t } from "i18next";
import { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import AutoModeRoundedIcon from "@mui/icons-material/AutoModeRounded";
import { useSelector } from "react-redux";

const SinglePraticaButtons = ({
  handleDocClick,
  handleUploadClick,
  apiCallDownload,
  openDeleteDialog,
  onRefreshDocs,
  onRefetch,
  onDocComposition,
  aiPrompt,
}) => {
  const appConfig = useSelector((state) => state.app.appConfig);
  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <div className="w-full flex ml-4">
      {appConfig.modules.services.serviceWithLLM && aiPrompt && (
        <CoreButtonHoverIcon
          onClick={onDocComposition}
          className=" m-1 flex flex-row space-x-2 border text-primary"
          testo={t("GenerateIA")}
          icon={<MemoryOutlinedIcon className={`text-primary`} />}
        />
      )}
      <CoreButtonHoverIcon
        onClick={onRefetch}
        className="text-blue-500 m-1 flex flex-row space-x-2 border"
        testo={t("Refresh")}
        icon={<RefreshRoundedIcon className={`fill-blue-500`} />}
      />
      <CoreButtonHoverIcon
        onClick={onRefreshDocs}
        className="text-orange-400 m-1 flex flex-row space-x-2 border"
        testo={"Assegna " + t("Documents")}
        icon={<AutoModeRoundedIcon className={`fill-orange-400`} />}
      />
      <CoreButtonHoverIcon
        onClick={handleDocClick}
        className="text-blue-600 m-1 flex flex-row space-x-2 border"
        testo={t("Documents")}
        icon={<FolderRoundedIcon className={`fill-blue-600`} />}
      />
      <CoreButtonHoverIcon
        onClick={handleUploadClick}
        className="text-green-500 m-1 flex flex-row space-x-2 border"
        testo={t("Upload")}
        icon={<UploadFileRoundedIcon className={`fill-green-500`} />}
      />
      <CoreButtonHoverIcon
        onClick={(e) => setAnchorEl(e.currentTarget)}
        className="text-stone-600 m-1 flex flex-row space-x-2 border"
        testo={t("Download")}
        icon={<FileDownloadRoundedIcon className={`fill-stone-600`} />}
      />
      <CoreButtonHoverIcon
        onClick={openDeleteDialog}
        className="text-red-500 m-1 flex flex-row space-x-2 border"
        testo={t("Delete")}
        icon={<DeleteOutlineRoundedIcon className={`fill-red-500`} />}
      />

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={() => apiCallDownload[0]()}>
          {t("Download")} Excel
        </MenuItem>
        <MenuItem onClick={() => apiCallDownload[1]()}>
          {t("Download")} Zip
        </MenuItem>
        <MenuItem onClick={() => apiCallDownload[2]()}>
          {t("Download")} PDF
        </MenuItem>
      </Menu>
    </div>
  );
};

export default SinglePraticaButtons;
